var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container login-container"},[_c('LoginForm',{attrs:{"userLogin":_vm.userLogin,"userSignUp":_vm.userSignUp},on:{"login":function($event){return _vm.login()},"signUp":function($event){return _vm.signUp()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }